export default __webpack_public_path__ + "static/media/2.ff1fd801.jpg";